import { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { SERVICES, LEGACY_SLUGS } from "@/components/site/data";
import { SERVICE_CONTENT } from "@/components/site/serviceContent";
import { serviceMeta } from "@/seo/routeMeta";
import { ServiceHero } from "@/components/service/ServiceHero";
import { OfferGrid, Benefits, Steps } from "@/components/service/ServiceSections";
import { ServiceIndustries, ServiceFaq, AreaLine } from "@/components/service/ServiceExtras";
import { ServiceQuote, OtherServices } from "@/components/service/ServiceQuote";
import NotFound from "@/pages/NotFound";

export default function ServicePage() {
  const { slug } = useParams();
  const service = SERVICES.find((s) => s.slug === slug);
  const preselect = useMemo(() => (service ? { service: service.title, ts: service.slug } : null), [service]);

  if (LEGACY_SLUGS[slug]) return <Navigate to={`/services/${LEGACY_SLUGS[slug]}`} replace />;
  if (!service) return <NotFound />;
  const c = SERVICE_CONTENT[service.id];

  return (
    <div data-testid={`service-page-${service.id}`}>
      <Seo {...serviceMeta(service)} />
      <ServiceHero service={service} content={c} />
      <OfferGrid content={c} />
      <Benefits content={c} />
      <Steps content={c} />
      <ServiceIndustries content={c} />
      <ServiceFaq content={c} />
      <AreaLine />
      <ServiceQuote content={c} preselect={preselect} />
      <OtherServices currentId={service.id} />
    </div>
  );
}
